export default "__VITE_ASSET__ykWy_KI4__"